import { Box, Button, CircularProgress, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import MapIcon from '@mui/icons-material/Map';
import DevicePage from '../DevicePage';
import useDeviceData from '../../hooks/useDeviceData';
import LocationTiles from '../Maps/LocationTiles';
import DeviceLocationActions from '../Maps/DeviceLocationActions';
import DeviceStatusPanel, { dashboardPanelSx } from './DeviceStatusPanel';
import './Dashboard.css';
import { FeaturedResourcesContent } from '../Resources/FeaturedResources';
import useResources from '../../hooks/useResources';

function DashboardContent({ unit, navigation }) {
    const { data, status, reload, retry } = useDeviceData(unit);
    const resources = useResources();
    // Device data determines the navigation; optional articles load independently.
    // DevicePage remounts this boundary when the account or selected unit changes.
    if (unit?.UnitSerNum && status === 'loading') {
        return <Box role="status" aria-live="polite" sx={{ minHeight: '50dvh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
            <CircularProgress aria-hidden="true" />
            <Typography>Loading dashboard...</Typography>
        </Box>;
    }
    return <>{navigation}<Box sx={{ maxWidth: 800, mx: 'auto', px: { xs: 1, sm: 0 }, pb: 2 }}>
        {!unit?.UnitSerNum ? <Typography>Select a customer to view their device status.</Typography>
            : status === 'error' || !data?.unitStatus || !Object.keys(data.unitStatus).length ? <Box>
                    <Typography color="error">Could not get unit status.</Typography>
                    <Button onClick={retry}>Retry</Button>
                </Box> : <>
                    <DeviceStatusPanel status={data.unitStatus} />
                    <Paper component="section" variant="outlined" sx={{ ...dashboardPanelSx, p: { xs: 2, sm: 3 } }}>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', gap: 2, mb: 1 }}>
                            <Box sx={{ flex: '1 1 220px', minWidth: 0 }}>
                                <LocationTiles location={data.lastKnownLocation} isUsingHomeLocation={data.useHomeLocation} showHome={false} />
                            </Box>
                            <Button component={RouterLink} to="/map" variant="outlined" startIcon={<MapIcon />} sx={{ minHeight: 48 }}>View map</Button>
                        </Box>
                        <DeviceLocationActions unit={unit} data={data} reload={reload} />
                    </Paper>
                </>}
        <FeaturedResourcesContent resources={resources} />
    </Box></>;
}

export default function Dashboard() {
    return <DevicePage content={DashboardContent} deferNavigation />;
}
